import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../user/context/AuthContext';

const WithAuth = ({ children }) => {
  
  console.log("WithAuth", children)
  const { isAuthenticated } = useAuth();
  console.log("isAuthenticated private routes==================>", { isAuthenticated })
  return isAuthenticated() ? children : <Navigate to="/" />;
};
export default WithAuth;
